import { Component } from '@angular/core';

@Component({
  selector: 'app-config-layout',
  template: `<div class="backDarkDrop min-h-screen"><router-outlet></router-outlet></div>`,
styles: [`

`]
// tslint:disable-next-line:component-class-suffix
}) export class AppConfigLayout {

}
